import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { convertToDVString } from './stringUtils'

export const filterLeavingSoonMessages = (notificationActions?: WpsRuntime.atv.wps.NotificationActionProps[]) =>
  (notificationActions || [] as WpsRuntime.atv.wps.NotificationActionProps[])
    .filter(({ severity, messageSource }) => severity === 'RELEVANT' && messageSource === 'LEAVING_SOON')
    .map(notification => convertToDVString(notification.message))